<template>

    <vx-card id="watchStatisticsBarChart" class="vs-con-loading__container">

        <h5 class="mb-3">{{infoText}}</h5>

        <vs-checkbox class="float-left" v-model="showPercentage">Show percentage</vs-checkbox>

        <template slot="actions">

            <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                <small class="flex cursor-pointer">
                    <span>{{metricTimes[timeRange]}}</span>
                    <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                </small>
                <vs-dropdown-menu class="w-48">
                    <vs-dropdown-item @click="timeRange = 1">Last day</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 7">Last 7 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 14">Last 14 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 30">Last 30 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 90">Last 90 days</vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

            <feather-icon icon="RefreshCwIcon" @click="loadData()"></feather-icon>

        </template>

        <vue-apex-charts v-if="chartOptions" type="bar" :height="chartHeight" :options="chartOptions" :series="chartData"/>

    </vx-card>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'

export default {
    props: {
        link: {
            type: String,
            required: true
        },
        infoText: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        VueApexCharts
    },
    data(){
        return {

            chartData: [],
            timeRange: 7,
            showPercentage: false,

            chartHeight: 100,

            metricTimes: {
                1: 'Last day',
                7: 'Last 7 days',
                14: 'Last 14 days',
                30: 'Last 30 days',
                90: 'Last 90 days'

            },

            chartOptions: null

        }
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#watchStatisticsBarChart',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get(this.link + '?days=' + this.timeRange + ((this.showPercentage) ? "&use_percentage=true" : ""))
            loadPromise.then(function(response) {
                thisIns.chartData = [
                    {
                        name: ((thisIns.showPercentage) ? "Percentage of all watched time" : "Watch time"),
                        data: JSON.parse(JSON.stringify(response.data)).data
                    }
                ]
                thisIns.chartHeight = JSON.parse(JSON.stringify(response.data)).categories.length * 50 + 100

                let xaxis = {
                    categories: response.data.categories,
                    axisBorder: {
                        show: false,
                    },
                }

                if(thisIns.showPercentage) {
                    xaxis.min = 0;
                    xaxis.max = 100;
                }

                thisIns.chartOptions = {
                    grid: {
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        stacked: true,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    xaxis,
                    tooltip: {
                        x: { show: false },
                        y: {
                            formatter: function(value) {
                                return ((value) ? ((thisIns.showPercentage) ? value.toFixed(3) : value.toFixed(0)) : 0) + ((thisIns.showPercentage) ? '%' : ' min')
                            }
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'left',
                        offsetX: 40
                    }
                }


            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#watchStatisticsBarChart > .con-vs-loading')
            })
        }
    },
    watch: {
        timeRange() {
            this.loadData()
        },
        showPercentage(){
            this.loadData()
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>
